const sitemap = () => {
	const sitemapHero = document.querySelector(".sitemap-hero");
	const sitemapBlock = document.querySelector(".sitemap-block");

	if (!sitemapHero || !sitemapBlock) return;

	const sectionCounters = sitemapBlock.querySelectorAll(".count");
	let totalPages = 0;

	sectionCounters.forEach((counter) => {
		const block = counter.closest(".block");
		if (!block) return;

		const pageItems = block.querySelectorAll("li");
		const pageCount = pageItems.length;

		totalPages += pageCount;

		const numberElement = counter.querySelector("b") || counter;
		numberElement.textContent = pageCount;
	});

	const heroCounter = sitemapHero.querySelector(".count");

	if (heroCounter) {
		heroCounter.textContent = totalPages;
	}
};

export { sitemap };
